/**
 * @generated SignedSource<<7d0727993fa99773a2e567e19f6414d2>>
 * @relayHash d7a5a315361ff38212511c14888ab4bd
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d7a5a315361ff38212511c14888ab4bd

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deleteMeasLaboratoryPrescriptionInput = {
  id: string;
};
export type useChDeleteMeasLaboratoryPrescriptionMutation$variables = {
  input: Ch_deleteMeasLaboratoryPrescriptionInput;
};
export type useChDeleteMeasLaboratoryPrescriptionMutation$data = {
  readonly ch_deleteMeasLaboratoryPrescription: {
    readonly ch_MeasLaboratoryPrescription: {
      readonly id: string;
    } | null;
  };
};
export type useChDeleteMeasLaboratoryPrescriptionMutation = {
  response: useChDeleteMeasLaboratoryPrescriptionMutation$data;
  variables: useChDeleteMeasLaboratoryPrescriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChDeleteMeasLaboratoryPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteMeasLaboratoryPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_deleteMeasLaboratoryPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_MeasLaboratoryPrescription",
            "kind": "LinkedField",
            "name": "ch_MeasLaboratoryPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChDeleteMeasLaboratoryPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteMeasLaboratoryPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_deleteMeasLaboratoryPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_MeasLaboratoryPrescription",
            "kind": "LinkedField",
            "name": "ch_MeasLaboratoryPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "d7a5a315361ff38212511c14888ab4bd",
    "metadata": {},
    "name": "useChDeleteMeasLaboratoryPrescriptionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "eea1df929fe605108dcb36f91cc9ce45";

export default node;
